import some from 'lodash/some';
import isObject from 'lodash/isObject';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

export const isNotEmptyString = (value: any): value is string => {
  return typeof value === 'string' && value.trim().length > 0;
};

export function extractWithDefault<T>(
  path: string,
  object: any,
  defaultValue: T
): T {
  return get(object, path, defaultValue);
}

export function getOrNull<T>(object, path: string) {
  return extractWithDefault(path, object, null);
}

export const hasTruthyOrNonEmpty = (values: Array<any>): boolean => {
  return values.some((value) =>
    Array.isArray(value) ? value.length > 0 : !!value
  );
};

export const hasAtLeastOnePropertyWithValue = (
  obj: Record<string, any>
): boolean => {
  const keys = Object.keys(obj);
  return keys.some((key) => obj[key] != null && obj[key] !== '');
};

export const hasPropertyWithValue = (
  obj: any,
  propertyPath: string
): boolean => {
  const value = get(obj, propertyPath);
  return value != null && value !== '';
};

export const nestedHasValue = (obj) => {
  if ((Array.isArray(obj) && isEmpty(obj)) || (isObject(obj) && isEmpty(obj))) {
    return false;
  }

  return some(obj, (value) => {
    if (Array.isArray(value) || isObject(value)) {
      return nestedHasValue(value);
    }
    return !!value;
  });
};

export const containsPrimitiveValue = (obj: any): boolean => {
  if (Array.isArray(obj)) {
    return obj.some((element) => containsPrimitiveValue(element));
  } else if (isObject(obj)) {
    return Object.values(obj).some((value) => containsPrimitiveValue(value));
  } else {
    return obj !== undefined && obj !== null && obj !== '';
  }
};

